import React from 'react';
import './SubTitle.css'

const SubTitle = ({children}) => {
    return (
        <div className='text-center mb-5'>
            <h4 className='subtitle relative text-black text-2xl '>{children}</h4>
        </div>
    );
};

export default SubTitle;